import BudgetIcon from "@assets/budget/budget-2026-logo.svg";
import Heading from "@elements/Typography/Heading";
import Link from "@elements/Typography/Link";
import GELiveBlog from "@pages/GeneralElections/Components/GELiveBlog";
import GETopStoryWidget from "@pages/GeneralElections/Components/GETopStoryWidget";
import { BUGET_2026_PAGE } from "@src/app/config/budget";
import { ProcessedArticleData } from "@transformer/useOSResponse";

export type GEWidgetProps = {
  geHeadline?: string;
  geRecordedVideo?: string;
  geTopStories?: ProcessedArticleData[];
  geLiveBlog?: string;
};

export function GEWidget({
  geRecordedVideo,
  geTopStories,
  geLiveBlog,
}: GEWidgetProps) {
  if ((geTopStories?.length ?? 0) === 0 && !geRecordedVideo && !geLiveBlog) {
    return <></>;
  }
  return (
    <div className="flex flex-col">
      <div className="h-[10px] bg-gradient-to-r from-blue-400 to-red-400 -mx-[10px] lg:hidden"></div>
      <div className="border-b-[1px] border-grey-400 py-[10px] md:py-[20px] mb-[10px] md:mb-[20px]">
        <Link className="gap-4 flex items-center" destination={BUGET_2026_PAGE}>
          <img src={BudgetIcon} alt="ge-icon" width={106} height={36} />
          <div className="flex gap-1 items-center group">
            <Heading
              className="text-red-100 hover:text-red-800 text-[18px] md:text-[23px]
              font-medium md:font-semibold font-primary leading-[100%] md:leading-[135%]"
            >
              Belanjawan 2026
            </Heading>
          </div>
        </Link>
      </div>
      <div className="flex gap-[30px]">
        <div className="w-full lg:w-[992px] xl:w-[778px] flex flex-col gap-5">
          {geRecordedVideo && (
            <div dangerouslySetInnerHTML={{ __html: geRecordedVideo }} />
          )}
          {geTopStories && <GETopStoryWidget articles={geTopStories} />}
          {geLiveBlog && (
            <div className="xl:hidden mx-[10px] lg:mx-0">
              <GELiveBlog variant="body" geLiveBlogContent={geLiveBlog} />
            </div>
          )}
        </div>
        <div className="hidden xl:block">
          {geLiveBlog && (
            <GELiveBlog
              variant="sidebar"
              geLiveBlogContent={geLiveBlog}
              styles={{ wrapperStyle: "w-[379px] h-full" }}
            />
          )}
        </div>
      </div>
    </div>
  );
}
